import React from "react";
import { Box, Typography } from "@mui/material";
import editorTokens from "../SignRequestEditor.tokens";

const { rightRail, palette } = editorTokens;

/**
 * The 46px title strip every right-rail panel wears in
 * `Sign Request Editor.dc.html`: glyph, bold title, and an optional trailing
 * action (the collapse chevron).
 */
const RightPanelHeader = ({
  icon,
  title,
  headerAction,
}: {
  icon: React.ReactNode;
  title: string;
  headerAction?: React.ReactNode;
}) => (
  <Box
    sx={{
      height: rightRail.headerHeight,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      gap: rightRail.headerGap,
      px: rightRail.headerPaddingX,
      borderBottom: `1px solid ${rightRail.borderColor}`,
    }}
  >
    <Box
      component="span"
      aria-hidden="true"
      sx={{ display: "flex", color: palette.ink }}
    >
      {icon}
    </Box>
    <Typography
      component="h2"
      sx={{
        fontSize: rightRail.headerFontSize,
        fontWeight: rightRail.headerFontWeight,
        color: palette.ink,
        lineHeight: "normal",
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </Typography>
    {headerAction && (
      <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
        {headerAction}
      </Box>
    )}
  </Box>
);

export default RightPanelHeader;
